import React from 'react';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import theme from './theme';
import AppShell from './layout/AppShell';

const globalStyles = (
  <GlobalStyles
    styles={{
      body: {
        margin: 0,
        padding: 0,
        overflow: 'hidden', // Block body scrolling - only panels scroll
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      },
      '#root': {
        height: '100vh',
        overflow: 'hidden'
      },
      // Ensure smooth scrolling within panels
      '*': {
        scrollBehavior: 'smooth'
      },
      // Custom scrollbars for panels
      '::-webkit-scrollbar': {
        width: '8px',
        height: '8px'
      },
      '::-webkit-scrollbar-track': {
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '4px'
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(255,255,255,0.2)',
        borderRadius: '4px',
        '&:hover': {
          background: 'rgba(255,255,255,0.3)'
        }
      }
    }}
  />
);

export default function App() {
  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {globalStyles}
        <AppShell />
      </ThemeProvider>
    </HashRouter>
  );
}
